import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
import { onFormInputKeyDown } from '../helpers/HelperFunctions';
import { v4 } from 'uuid';
export class DateTimeField extends Component {
    static propTypes = {
        label: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        format: PropTypes.string,
        name: PropTypes.string,
        placeholder: PropTypes.string,
        value: PropTypes.string,
        valueToShow: PropTypes.string,
        onChange: PropTypes.func,
        error: PropTypes.string,
        id: PropTypes.string
    };
    constructor(props) {
        super(props);
        const { value } = this.props;
        this.state = {
            valueToShow: value ? moment(value, "YYYY-MM-DD").format("DD.MM.YYYY") : '',
            value: value ?? '',
            id: v4()
        };
        this.handleChange = this.handleChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onFireFoxLabelClick = this.onFireFoxLabelClick.bind(this);
    }
    componentDidUpdate() {
        if (this.props.canUpdate) {
            const value = this.props.value ?? '';
            if (value !== this.state.value) {
                this.setState({
                    value: value,
                    valueToShow: value ? moment(value.includes('T') ? value.split('T')[0] : value, "YYYY-MM-DD").format("DD.MM.YYYY") : ''
                });
            }
        }
    }
    render() {
        const { name, disabled } = this.props;
        const { value, valueToShow, id } = this.state;
        return (<div className="date-input-contaner" id={id} key={id}>
            <input className="datetime-input-control form-control"
                type="date"
                name={name}
                value={value}
                valuetoshow={valueToShow}
                onFocus={this.onFocus}
                onBlur={this.onFocusOut}
                onKeyDown={onFormInputKeyDown}
                onChange={this.handleChange}
                placeholder={this.props.placeholder}
                disabled={(disabled ? "disabled" : "")}
            />
            <div className="fire-fox-date-label" onClick={this.onFireFoxLabelClick}>
                {valueToShow}
            </div>
            <div className="fire-fox-date-icon">
                <img src="/img/calendar.svg" alt="" />
            </div>
        </div>);
    }
    onFocus(e) {
        const { format } = this.props;
        const { id } = this.state;
        e.target.type = format ? format : "datetime-local";

        let element = document.getElementById(id);
        if (element) {
            let firefoxLabel = element.querySelector('.fire-fox-date-label');
            if (firefoxLabel)
                firefoxLabel.classList.add('focus');
        }
    }
    onFocusOut(e) {
        const { id } = this.state;

        let element = document.getElementById(id);
        if (element) {
            let firefoxLabel = element.querySelector('.fire-fox-date-label');
            if (firefoxLabel)
                firefoxLabel.classList.remove('focus');
        }
    }
    onFireFoxLabelClick(e) {
        const { id } = this.state;

        let element = document.getElementById(id);
        if (element) {
            let input = element.querySelector('input');
            if (input)
                input.focus();
        }
    }
    handleChange(e) {
        const { value } = e.target;
        this.setState({
            value: value ? value : null,
            valueToShow: value ? moment(value.includes('T') ? value.split('T')[0] : value, "YYYY-MM-DD").format("DD.MM.YYYY") : ''
        });
        if (this.props.onChange)
            this.props.onChange(e);
    }
}